<template>
    <vue100vh style="position: fixed; width: -webkit-fill-available;">
    <div style="height: calc(100vh - 64px); overflow-x: hidden; overflow-y: scroll;">
      <v-toolbar style="background-color: white !important;">
        <v-btn icon @click="toPage('/web/listmenu')">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title>{{$t('Settings.helpCenter.header')}}</v-toolbar-title>
      </v-toolbar>
        <br>
        <br>
        <div  style="text-align: center; margin-top: 0px;">
          <img :src="`${publicPath}/assets/img/onechat/map.png`" width="400">
        </div>
          <br>
          <div style="padding: 3vw;">
          <b style="font-size: 18px;" class="CSChatThai">{{$t('Settings.helpCenter.company')}}<br> {{$t('Settings.helpCenter.address')}}</b>
          </div>
          <div style="padding-left: 3vw;font-size: 16px;" class="CSChatThai">
            <b>{{$t('Settings.helpCenter.email')}}: <a href="mailto:onechat@one.th" class="">onechat@one.th</a></b>
          </div>
    </div>
  </vue100vh>
  </template>
  <script type="text/javascript">
  import vue100vh from 'vue-100vh'
  export default {
    data: () => ({
        publicPath: process.env.VUE_APP_BASE_PATH,
    }),
    methods: {
      toPage (data) {
        this.$router.push(data)
      }
    },
    components: {
      vue100vh
    },
    created () {
      this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
    }
  }
  </script>
  <style type="text/css" scoped>
  >>>.v-toolbar {
    /* box-shadow: none; */
    box-shadow: 0 2px 0px -1px hsla(0,0%,100%,.12), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12) !important;
  }
  .CSChatThai {
    font-family: 'CS ChatThaiUI' !important;
    word-wrap: break-word;
  }
  a:link {
      text-decoration: none;
      color: black !important;
  }
  
  a:visited {
      color: white !important;
      text-decoration: none;
  }
  
  a:hover {
      color: #1e88e5 !important;
      text-decoration: none;
  }
  
  a:active {
      color: black !important;
      text-decoration: none;
  }
  </style>